import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { BookingInfo, OtherActions } from './components';
import { AccountPreview, LessonPreview, TransactionPreview, SlotPreview, StudentPreview } from 'components';

const useStyles = makeStyles(theme => ({
  root: {},
  card: {
    marginBottom: theme.spacing(3),
  }
}));

const Summary = props => {
  const { className, handleDelete, reload, ...rest } = props;
  const model = useSelector(state => state.models.booking);

  const classes = useStyles();

  if (!model) {
    return null;
  }

  return (
    <Grid {...rest} className={clsx(classes.root, className)} container spacing={3}>
      <Grid item lg={4} md={6} xl={3} xs={12}>
        <BookingInfo className={classes.card} />
        <OtherActions handleDelete={handleDelete} className={classes.card} />
      </Grid>
      <Grid item lg={4} md={6} xl={3} xs={12}>
        <LessonPreview lessonId={model.lesson_slot.lesson_id} />
        <TransactionPreview transactionId={model.transaction_id} />
        <SlotPreview slotId={model.lesson_slot_id} />
      </Grid>
      <Grid item lg={4} md={6} xl={3} xs={12}>
        <AccountPreview accountId={model.student.account_id} />
        <StudentPreview studentId={model.student_id} />
      </Grid>
    </Grid>
  );
};

Summary.propTypes = {
  className: PropTypes.string
};

export default Summary;
